var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEraser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.575 5.965l-3.538-3.538a1.875 1.875 0 00-2.65 0L2.425 11.39a1.875 1.875 0 000 2.65l2.831 2.837H3.75a.625.625 0 100 1.25h12.5a.625.625 0 000-1.25H9.312l8.263-8.262a1.875 1.875 0 000-2.65zM7.28 16.877a.625.625 0 01-.437-.181l-3.538-3.538a.625.625 0 010-.88l2.169-2.17 4.418 4.42-2.168 2.168a.625.625 0 01-.438.181h-.006zm9.413-9.15l-5.919 5.919-4.419-4.419 5.919-5.918a.625.625 0 01.881 0l3.538 3.568a.625.625 0 010 .85z",
    fill: "#000"
  })));
}
export default SvgEraser;